module.exports = __webpack_public_path__ + "static/img/home02.1b35c38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home02.png
// module id = AiWF
// module chunks = 1